import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

/**
 * AccessibilityAnnouncer component that provides screen reader announcements
 * This component renders aria-live regions that announce feedback and other important messages
 */
const AccessibilityAnnouncer = observer(() => {
  const { accessibilityService } = useContext(MobXProviderContext);

  return (
    <>
      {/* Feedback announcement region */}
      <div 
        id="feedbackAnnouncement"
        aria-live="assertive" 
        aria-atomic="true"
        className="sr-only"
        role="status"
      >
        {accessibilityService.feedbackAnnouncement}
      </div>
    </>
  );
});

export default AccessibilityAnnouncer; 